import React from "react";
import { Route } from "react-router-dom";

const NormalRoute = (props) => {
  const { ...rest } = props;
  return <Route {...rest} />;
};

export { NormalRoute };
